export enum ModuleCommandStatusEnum {
    REJECTED = "rejected",
    CREATED = "created",
    SENDING = "sending",
    RECEIVED_BY_GATEWAY = "received_by_gateway",
  }